export default __webpack_public_path__ + "static/media/english-to-chinese-screenshot-03.5f16b263.png";